module.exports = __webpack_public_path__ + "img/profile-icon-bg-white.3e78a3fe.svg";